module.exports = __webpack_public_path__ + "static/media/worry-free-8.7d24e782.png";